import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Building2, LayoutPanelTop, Mountain, Factory, TrainFront, Boxes } from "lucide-react";
import Reveal from "@/components/landing/Reveal";

const AREAS = [
  {
    id: "brueckeninspektion", icon: Building2, index: "01", title: "Brücken & Bauwerke",
    text: "Drohnenbasierte technische Datenerfassung an Brücken und Bauwerken. Hochauflösende Detailaufnahmen von Überbauten, Pfeilern, Widerlagern, Unterseiten und weiteren schwer zugänglichen Bereichen.",
    keywords: ["Drohneninspektion Brücke", "Brückeninspektion", "Bauwerksinspektion"],
  },
  {
    id: "fassadeninspektion", icon: LayoutPanelTop, index: "02", title: "Fassaden & Hochhäuser",
    text: "Digitale Fassadenerfassung und hochauflösende Dokumentation schwer zugänglicher Gebäudebereiche.",
    keywords: ["Fassadeninspektion Drohne", "Hochhausinspektion", "Fassadenprüfung Drohne"],
  },
  {
    id: "stuetzwaende-hangsicherung", icon: Mountain, index: "03", title: "Stützwände & Hangsicherungen",
    text: "Technische Dokumentation von Stützwänden, Böschungen, Hangsicherungen und schwer zugänglichen Bereichen.",
    keywords: ["Stützwand Inspektion", "Hangsicherung Inspektion", "Böschungsinspektion"],
  },
  {
    id: "industrieinspektion", icon: Factory, index: "04", title: "Industrie & technische Anlagen",
    text: "Technische Datenerfassung an Industrieanlagen und schwer zugänglichen technischen Konstruktionen.",
    keywords: ["Industrieinspektion Drohne", "Industrieanlagen Inspektion", "technische Drohneninspektion"],
  },
  {
    id: "bahninfrastruktur", icon: TrainFront, index: "05", title: "Bahn & Verkehrsinfrastruktur",
    text: "Technische Datenerfassung an Brücken, Überführungen und weiteren Infrastrukturbauwerken.",
    keywords: ["Bahninspektion Drohne", "Infrastrukturinspektion", "Verkehrsinfrastruktur Drohne"],
  },
  {
    id: "photogrammetrie-3d", icon: Boxes, index: "06", title: "3D & Photogrammetrie",
    text: "Aus Bilddaten entstehen auf Wunsch Orthofotos, Punktwolken und 3D-Modelle zur digitalen Bestandsdokumentation.",
    keywords: ["Photogrammetrie Drohne", "3D Vermessung Drohne", "RTK Vermessung Drohne"],
  },
];

export default function Leistungsbereiche() {
  return (
    <section id="leistungen" data-testid="leistungsbereiche-section" className="relative border-b border-white/10">
      <div className="px-6 py-20 lg:px-16 lg:py-28">
        <Reveal>
          <p className="font-tac text-xs tracking-[0.3em] text-[#F5B301]">TECHNISCHE SPEZIALINSPEKTIONEN</p>
          <h2 className="mt-6 max-w-4xl font-display text-4xl font-black uppercase leading-[0.9] tracking-tighter sm:text-5xl lg:text-6xl">
            Unsere <span className="text-[#F5B301]">Leistungsbereiche.</span>
          </h2>
          <p className="mt-6 max-w-2xl font-tac text-sm leading-relaxed text-[#A1A1AA]">
            Drohnengestützte Datenerfassung und digitale Dokumentation schwer zugänglicher Bauwerke und Anlagen —
            als belastbare Grundlage für die fachliche Bewertung durch Ihre Ingenieure.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-px overflow-hidden border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {AREAS.map((a, i) => {
            const Icon = a.icon;
            return (
              <Reveal key={a.id} delay={i * 0.06}>
                <Link
                  to={`/${a.id}`}
                  data-testid={`leistung-card-${a.id}`}
                  className="group flex h-full flex-col bg-[#09090B] p-8 transition-colors duration-300 hover:bg-white/[0.03]"
                >
                  <div className="flex items-center justify-between">
                    <span aria-hidden="true" className="font-display text-3xl font-black leading-none text-stroke opacity-40">{a.index}</span>
                    <Icon className="h-8 w-8 text-[#F5B301]/70 transition-colors group-hover:text-[#F5B301]" strokeWidth={1.5} />
                  </div>
                  <h3 className="mt-8 font-display text-2xl font-black uppercase leading-none tracking-tighter text-white transition-colors group-hover:text-[#F5B301]">{a.title}</h3>
                  <p className="mt-4 flex-1 font-tac text-xs leading-relaxed text-[#A1A1AA]">{a.text}</p>
                  <div className="mt-6 flex flex-wrap gap-2">
                    {a.keywords.map((k) => (
                      <span key={k} className="border border-white/10 px-2 py-1 font-tac text-[9px] tracking-[0.15em] text-white/45">{k}</span>
                    ))}
                  </div>
                  <span className="mt-7 inline-flex items-center gap-2 font-tac text-[11px] tracking-[0.25em] text-white/80 transition-colors group-hover:text-[#F5B301]">
                    MEHR ERFAHREN <ArrowUpRight className="h-4 w-4" />
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
